// extracted by mini-css-extract-plugin
export default {"wrapper":"select-address_wrapper__JzzuX","box":"select-address_box__TPPv7","title":"select-address_title__5aRVw"};